import { useFormikContext } from 'formik';
import { Checkbox } from '@schibsted-svp/react-ui';
import get from 'lodash/get';

type Props = {
  name: string;
};

function UpcomingAssetsCheckbox({ name }: Props) {
  const { setFieldValue, values } = useFormikContext<Record<string, unknown>>();
  const isChecked = get(values, name) === '{{current_timestamp}}';

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { checked } = event.target;

    if (checked) {
      setFieldValue(name, '{{current_timestamp}}');
    } else {
      setFieldValue(name, null);
    }
  }

  return (
    <div className="container">
      <Checkbox
        label="Filter out upcoming assets"
        onChange={onChange}
        checked={isChecked}
      />
    </div>
  );
}

export { UpcomingAssetsCheckbox };
